import {initAjaxForm} from "../../../src/js/core/forms";

export const initContactForm = () => {
    const form = document.getElementById('contact-form');

    if (!form) {
        return
    }

    initAjaxForm(form, 'submit_contact_form', '/contact-thankyou')
}
